"use strict";

var api = {

    debug: true,

    log: function log(message) {
        if (api.debug) {
            toastr.warning(message);
        }
    }
};

module.exports = api;